'use client';

import { ArrowRight, Sparkles } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

/**
 * Compact "Create Your Art" promotion, shown below the initial catalog results
 * so it never competes with shopping at the top of the page.
 */
export function ShopPromoCard() {
  const t = useTranslations('shop.shopClient.promo');

  return (
    <div className="relative overflow-hidden rounded-2xl border border-amber-200/70 bg-gradient-to-br from-amber-50 to-orange-50 p-5 dark:border-amber-500/20 dark:from-slate-900 dark:to-slate-800 sm:p-6">
      <div className="relative flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-500/15 text-amber-600 dark:text-amber-400">
            <Sparkles className="h-5 w-5" />
          </span>
          <div>
            <h2 className="text-base font-semibold text-gray-900 dark:text-white sm:text-lg">
              {t('title')}
            </h2>
            <p className="mt-0.5 text-sm text-gray-600 dark:text-gray-300">{t('description')}</p>
          </div>
        </div>
        <Link
          href="/create"
          className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-2.5 text-sm font-semibold text-white transition-all hover:shadow-lg hover:shadow-amber-500/25"
        >
          {t('button')}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
